export default function TS_Keyof() {
  return (
    <div>
      <h1>TS Keyof</h1>
      <p>This is the TS Keyof page.</p>
    </div>
  );
}